// extracted by mini-css-extract-plugin
export default {"content":"AppRoute_content__NKgKU"};